import {Form} from 'antd'
import apiBaseline from '@/biz/baseline/apiBaseline.mjs'
import Checkbox from '@/components/Form/Checkbox.jsx'
import TextArea from '@/components/Form/TextArea.jsx'
import {Modal, useOpenModal} from '@/components/Modal/index.mjs'
import {AbortError} from '@/script/Error.mjs'
import useSwrNoCache from '@/script/useSwrNoCache.mjs'

const FormItemUpgrade = ({prjId, sVer, ...props}) => {
    const {data} = useSwrNoCache(
        () => apiBaseline.read({prjId, sVer})
    )

    if ('INCREMENT' === data?.pblType) {
        return null
    }

    return (
        <Form.Item name="upgradeDp" {...props}>
            <Checkbox>制品升版</Checkbox>
        </Form.Item>
    )
}

const ModalPublish = ({prjId, sVer, onOk, ...props}) => {
    const [form] = Form.useForm()

    const handleOk = () => {
        form.submit()
    }

    const cssForm = {
        '.ant-form-item': {
            marginBottom: 0,
        }
    }

    return (
        <Modal
            title="发布模型制品"
            width={400}
            {...props}
            onOk={handleOk}
            onFinish={onOk}
            css={cssForm}
        >
            <Form
                form={form}
                layout="vertical"
                onFinish={onOk}
            >
                <Form.Item name="memo">
                    <TextArea
                        autoSize={false}
                        rows={5}
                        placeholder="备注"
                    />
                </Form.Item>

                <FormItemUpgrade
                    prjId={prjId}
                    sVer={sVer}
                />
            </Form>
        </Modal>
    )
}

export const usePluginPublishProduct = () => {
    const openModal = useOpenModal()

    const extensions = () => {
        return {
            canPublishProduct() {
                if (! this.permission.has('write')) {
                    this.logger.error('没有发布权限')
                    return false
                }

                const bn = this.BizNode[this.componentType ?? this.productType]

                if ('function' !== typeof bn.publish) {
                    this.logger.error('不支持发布')
                    return false
                }

                const {stsCode} = this.root.data

                if (! /^(DRAFT|REVISE)$/.test(stsCode)) {
                    this.logger.error('只有草稿/修订状态才能发布')
                    return false
                }

                return true
            },

            async cmdPublishProduct() {
                await this.runAction(
                    () => this.execute(
                        () => this.publishProduct()
                    ),

                    {action: '发布模型制品'},
                )
            },

            async publishProduct() {
                const {prjId, sVer} = this.data

                const extra = await openModal(
                    <ModalPublish
                        prjId={prjId}
                        sVer={sVer}
                    />
                )

                if (! extra) {
                    throw new AbortError()
                }

                const bn = this.BizNode[this.componentType ?? this.productType]
                await bn.publish(this, this.root)
                this.resetChangeHistory()
            },

            useCanPublishProduct() {
                this.usePermission()
                this.useNodeChange(this.root, ['data'])
                return this.canPublishProduct()
            },
        }
    }

    return {extensions}
}
